module.exports = __webpack_public_path__ + "assets/img/12.aad5a3bd.png";